export const loginUrl = '/login';
export const timeRecordingsUrl = '/time-recordings';
export const twoFactorSecretsUrl = '/two-factor-secrets';
